import React from "react";

// Header genérico
import HeaderPasos from "../../../componentsUI/estructura/headerPasos/headerPasos.js";

// Componentes
import EjecutarInventarioInicial from "../inventarioInicial/ModuloInventarioInicial.js";
import ListaItemsActualiados from "../itemsActualizados/itemsActualizados.js";
import ListaItemsCompuesto from "../itemProductoCompuestos/tabla/itemCompuestoLista.js";
import TablaInventarioXMetodo from "../itemMovimientos/totalesMovimientos/tablaMovimiento.js";

export default function TemplateInventario() {
  const pasosInventario = [
    {
      id: "inicial",
      label: "Inventario Inicial",
      component: (
        <div >
          <EjecutarInventarioInicial />
        </div>
      ),
    },
    {
      id: "actualizado",
      label: "Inventario Aprobado",
      component: (
        <>
          <div >
            <ListaItemsActualiados />
          </div>
        </>
      ),
    },
      {
      id: "bom",
      label: "Inventario BOM",
      component: (
        <div >
          <ListaItemsCompuesto />
        </div>
      ),
    },
    {
      id: "movimientos",
      label: "Movimientos Inventario",
      component: (
        <div className="confirmar-pedido-section">
          <TablaInventarioXMetodo />
        </div>
      )},
  
  ];

  return (
    <HeaderPasos
      titulo="inicial"
      pasos={pasosInventario}
      pasoInicial="inicial"
    />
  );
}
